module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("老师管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("培训中老师")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 60,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "HR"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "transfer": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.hr),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "hr", $$v)
      },
      expression: "queryParam.hr"
    }
  }, _vm._l((_vm.$constant.hrList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "外教运营"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "transfer": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.studyAdviserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "studyAdviserId", _vm._n($$v))
      },
      expression: "queryParam.studyAdviserId"
    }
  }, _vm._l((_vm.studyAdviserList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "是否分配外教运营",
      "label-width": 109
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "transfer": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.isStudyAdviser),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "isStudyAdviser", _vm._n($$v))
      },
      expression: "queryParam.isStudyAdviser"
    }
  }, _vm._l((_vm.$constant.isStudyAdviser), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "口音：",
      "label-width": 80
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "transfer": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.accent),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "accent", _vm._n($$v))
      },
      expression: "queryParam.accent"
    }
  }, _vm._l((_vm.$constant.accent), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "性别：",
      "label-width": 80
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "transfer": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.sex),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "sex", _vm._n($$v))
      },
      expression: "queryParam.sex"
    }
  }, _vm._l((_vm.$constant.sex), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师ID",
      "prop": "id"
    }
  }, [_c('Input', {
    attrs: {
      "name": "id"
    },
    model: {
      value: (_vm.queryParam.id),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "id", $$v)
      },
      expression: "queryParam.id"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师昵称"
    }
  }, [_c('Input', {
    attrs: {
      "name": "name",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.name),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "name", $$v)
      },
      expression: "queryParam.name"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师账号"
    }
  }, [_c('Input', {
    attrs: {
      "name": "account",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.account),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "account", $$v)
      },
      expression: "queryParam.account"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "授课类型",
      "prop": "tchType"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "data-value": "-1",
      "transfer": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.tchType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchType", _vm._n($$v))
      },
      expression: "queryParam.tchType"
    }
  }, [_c('Option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("全部")]), _vm._v(" "), _vm._l((_vm.$constant.tchType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  })], 2)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "来源："
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "transfer": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.channel),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "channel", _vm._n($$v))
      },
      expression: "queryParam.channel"
    }
  }, _vm._l((_vm.$constant.tchChannel), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "注册渠道"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "transfer": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.regFrom),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "regFrom", $$v)
      },
      expression: "queryParam.regFrom"
    }
  }, _vm._l((_vm.channelOptions), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.param
      }
    }, [_vm._v(_vm._s(item.status === 0 ? (item.name + '（停用）') : item.name))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "推荐人"
    }
  }, [_c('Input', {
    attrs: {
      "name": "inviteTchName",
      "placeholder": "推荐人姓名"
    },
    model: {
      value: (_vm.queryParam.inviteTchName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "inviteTchName", $$v)
      },
      expression: "queryParam.inviteTchName"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "注册时间"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "format": "yyyy-MM-dd",
      "type": "daterange",
      "clearable": "",
      "placement": "bottom-start",
      "placeholder": ""
    },
    on: {
      "on-change": _vm.createDateChange
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _c('Row', [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading,
      "disable": _vm.exportLoading
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.allTeachersLeave
    }
  }, [_vm._v("全体老师请假")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.batchReject
    }
  }, [_vm._v("批量拒绝")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onAssignAdviser
    }
  }, [_vm._v("分配外教运营")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addTch
    }
  }, [_vm._v("添加老师")])], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "reloadWithPage": _vm.reloadWithPage,
      "listUrl": "/tch/training/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading
    },
    on: {
      "on-selection-change": _vm.selectionChange
    }
  }), _vm._v(" "), _c('TchCancelOpenedTimeModal', {
    attrs: {
      "tchId": _vm.tchId,
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.showTchCancelOpenedTimeModal),
      callback: function($$v) {
        _vm.showTchCancelOpenedTimeModal = $$v
      },
      expression: "showTchCancelOpenedTimeModal"
    }
  }), _vm._v(" "), _c('TchAddOpenedTimeModal', {
    attrs: {
      "tchId": _vm.tchId,
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.showTchAddOpenedTimeModal),
      callback: function($$v) {
        _vm.showTchAddOpenedTimeModal = $$v
      },
      expression: "showTchAddOpenedTimeModal"
    }
  }), _vm._v(" "), _c('TchEditOpenedTimeModal', {
    attrs: {
      "tchId": _vm.tchId,
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.showTchEditOpenedTimeModal),
      callback: function($$v) {
        _vm.showTchEditOpenedTimeModal = $$v
      },
      expression: "showTchEditOpenedTimeModal"
    }
  }), _vm._v(" "), _c('TchCancelRandomOpenedTimeModal', {
    attrs: {
      "tchId": _vm.tchId,
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.showCancelRandomOpenedTimeModal),
      callback: function($$v) {
        _vm.showCancelRandomOpenedTimeModal = $$v
      },
      expression: "showCancelRandomOpenedTimeModal"
    }
  }), _vm._v(" "), _c('TchAddRandomOpenedTimeModal', {
    attrs: {
      "tchId": _vm.tchId,
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.showTchAddRandomOpenedTimeModal),
      callback: function($$v) {
        _vm.showTchAddRandomOpenedTimeModal = $$v
      },
      expression: "showTchAddRandomOpenedTimeModal"
    }
  }), _vm._v(" "), _c('TchLeaveModal', {
    attrs: {
      "tchId": _vm.tchId,
      "substituteList": _vm.substituteList
    },
    on: {
      "getProxyClassData": _vm.showProxyClass,
      "getCancelProxyClassData": _vm.cancelProxyClassData
    },
    model: {
      value: (_vm.showTchLeaveModal),
      callback: function($$v) {
        _vm.showTchLeaveModal = $$v
      },
      expression: "showTchLeaveModal"
    }
  }), _vm._v(" "), _c('TchLeaveOfficeModal', {
    attrs: {
      "tchId": _vm.tchId,
      "substituteList": _vm.substituteList
    },
    on: {
      "getProxyClassData": _vm.showProxyClass,
      "getCancelProxyClassData": _vm.cancelProxyClassData
    },
    model: {
      value: (_vm.showTchLeaveOfficeModal),
      callback: function($$v) {
        _vm.showTchLeaveOfficeModal = $$v
      },
      expression: "showTchLeaveOfficeModal"
    }
  }), _vm._v(" "), _c('AssignTchStudyAdviserModal', {
    attrs: {
      "successCallback": _vm.searchWithPage,
      "tchList": _vm.selectionTch
    },
    model: {
      value: (_vm.showAssignTchStudyAdviserModal),
      callback: function($$v) {
        _vm.showAssignTchStudyAdviserModal = $$v
      },
      expression: "showAssignTchStudyAdviserModal"
    }
  }), _vm._v(" "), _c('TchInsertModal', {
    attrs: {
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.tchInsertModal),
      callback: function($$v) {
        _vm.tchInsertModal = $$v
      },
      expression: "tchInsertModal"
    }
  }), _vm._v(" "), _c('AllTeachersLeaveModal', {
    model: {
      value: (_vm.showAllTeacherLeaveModel),
      callback: function($$v) {
        _vm.showAllTeacherLeaveModel = $$v
      },
      expression: "showAllTeacherLeaveModel"
    }
  }), _vm._v(" "), _c('tch-info-modal', {
    attrs: {
      "value": _vm.showTchInfoModal,
      "tchId": _vm.tchId,
      "successCallback": _vm.searchWithPage,
      "addType": _vm.addType,
      "recruit-flow-entry": "培训中老师"
    },
    on: {
      "on-close": function($event) {
        _vm.showTchInfoModal = false
      }
    }
  }), _vm._v(" "), _c('EditDingDingModal', {
    attrs: {
      "tchId": _vm.tchId,
      "value": _vm.showEditDingModal,
      "successCallback": _vm.searchWithPage
    },
    on: {
      "on-close": _vm.closeEditDingModal
    }
  }), _vm._v(" "), _c('TeachersDingTalkModal', {
    attrs: {
      "tchId": _vm.tchId,
      "value": _vm.showTeacherDingTalkModal,
      "successCallback": _vm.searchWithPage
    },
    on: {
      "on-close": _vm.closeTeacherDingTalkModal
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "选择代课老师"
    },
    model: {
      value: (_vm.showSelectTch),
      callback: function($$v) {
        _vm.showSelectTch = $$v
      },
      expression: "showSelectTch"
    }
  }, [_c('Form', {
    attrs: {
      "model": "selectTchParam"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_vm._v("\n          课节时间：" + _vm._s(_vm.lsnBeginTime) + "\n        ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_vm._v("\n          学生姓名：" + _vm._s(_vm.selectTchParam.uid + '-' + _vm.selectTchParam.userNickname) + "\n        ")])], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_vm._v("\n          学习导师：" + _vm._s(_vm.selectTchParam.studyAdviserNickname) + "\n        ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_vm._v("\n          课程顾问：" + _vm._s(_vm.selectTchParam.adviserNickname) + "\n        ")])], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "span": "16"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "代课老师：",
      "label-width": 80
    }
  }, [_c('substitute-tch-select', {
    attrs: {
      "dataL": _vm.activityList,
      "openedId": _vm.selectTchParam.openedId
    },
    model: {
      value: (_vm.substituteTchId),
      callback: function($$v) {
        _vm.substituteTchId = $$v
      },
      expression: "substituteTchId"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.showSelectTch = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.updateTch
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "审核拒绝"
    },
    model: {
      value: (_vm.showRejectModal),
      callback: function($$v) {
        _vm.showRejectModal = $$v
      },
      expression: "showRejectModal"
    }
  }, [_c('Form', {
    ref: "rejectForm",
    staticClass: "form",
    attrs: {
      "model": _vm.rejectParam,
      "rules": _vm.rejectRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('label', [_vm._v("确定 "), _c('b', [_vm._v(_vm._s(_vm.rejectParam.id) + " - " + _vm._s(_vm.rejectParam.firstName) + " " + _vm._s(_vm.rejectParam.lastName))]), _vm._v(" 老师未审核通过")])])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "类型",
      "prop": "leaveKind"
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.rejectParam.leaveKind),
      callback: function($$v) {
        _vm.$set(_vm.rejectParam, "leaveKind", $$v)
      },
      expression: "rejectParam.leaveKind"
    }
  }, [_c('Radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("淘汰")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("流失")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "理由",
      "prop": "remark"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 3
      },
      "maxlength": 100,
      "placeholder": "长度不要超过100个字"
    },
    model: {
      value: (_vm.rejectParam.remark),
      callback: function($$v) {
        _vm.$set(_vm.rejectParam, "remark", $$v)
      },
      expression: "rejectParam.remark"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.showRejectModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "error",
      "size": "large",
      "loading": _vm.loadingReject
    },
    on: {
      "click": _vm.reject
    }
  }, [_vm._v("拒绝")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "800",
      "title": "操作记录"
    },
    model: {
      value: (_vm.showTchChangeModal),
      callback: function($$v) {
        _vm.showTchChangeModal = $$v
      },
      expression: "showTchChangeModal"
    }
  }, [_c('Table', {
    attrs: {
      "columns": _vm.tchChangeStatusColumn,
      "data": _vm.tchChangeStatusList
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })], 1), _vm._v(" "), _c('send-email-modal', {
    attrs: {
      "visible": _vm.showEmailModal,
      "tchId": _vm.emailTchId,
      "tchName": _vm.emailTchName,
      "successCallback": _vm.search
    },
    on: {
      "on-close": function($event) {
        _vm.showEmailModal = false
      }
    }
  }), _vm._v(" "), _c('tch-apply-form-modal', {
    attrs: {
      "visible": _vm.showApplyModal,
      "tchId": _vm.applyTchId
    },
    on: {
      "on-close": function($event) {
        _vm.showApplyModal = false
      }
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "批量审核"
    },
    model: {
      value: (_vm.showBatchReviewModal),
      callback: function($$v) {
        _vm.showBatchReviewModal = $$v
      },
      expression: "showBatchReviewModal"
    }
  }, [_c('Form', {
    ref: "reviewForm",
    staticClass: "form",
    attrs: {
      "model": _vm.reviewParam,
      "rules": _vm.rejectRule,
      "label-width": 90
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "待审核老师："
    }
  }, _vm._l((_vm.selectionTch), function(item) {
    return _c('Tag', {
      key: item.id,
      attrs: {
        "name": item.id
      }
    }, [_vm._v("\n              " + _vm._s(item.id + ' - ' + item.firstName + ' ' + item.lastName) + "\n            ")])
  }), 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "类型：",
      "prop": "leaveKind"
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.reviewParam.leaveKind),
      callback: function($$v) {
        _vm.$set(_vm.reviewParam, "leaveKind", $$v)
      },
      expression: "reviewParam.leaveKind"
    }
  }, [_c('Radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("淘汰")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("流失")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "理由：",
      "prop": "remark"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 3
      },
      "maxlength": 100,
      "placeholder": "长度不要超过100个字"
    },
    model: {
      value: (_vm.reviewParam.remark),
      callback: function($$v) {
        _vm.$set(_vm.reviewParam, "remark", $$v)
      },
      expression: "reviewParam.remark"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.batchReview
    }
  }, [_vm._v("拒绝")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2197f2b1","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/teacher/TchTrainingList.vue
// module id = 1674
// module chunks = 8